var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { AdjustmentTypeList, branchListUrl, branchToBranchInwardAttachmentList, branchToBranchInwardOtherDetails, branchToBranchInwardPagingAPI, checkDefaultTrackingTypeAPI, completedStockTransferRequisitionAPI, createBranchToBranchInwardAPI, getAvailableQtyByWarehouseAPI, getAvailableQuantityAPI, getByBranchToBranchInwardIdAPI, getPriorityListAPI, getProductPriceAPI, getStatusProgessAPI, LocationByWarehouseList, OrganizationModulesItemSettingUrl, ProductList, SerialNumberList, ShippingMethodGetListAPI, StatusList, stockTransferRequisitionAttachmentCreateAPI, stockTransferRequisitionAttachmentDeleteAPI, stockTransferRequisitionWithDetailsAPI, TransporterListUrl, WarehouseList } from "../../../api/url";
import { genAttachmentURL } from "../../../builderPackage/common/commonFunctions";
import { createAPI, getByIdAPI, getListAPI, uploadAttachmentAPI } from "../../../redux/crudSlice";
import { store } from "../../../store/store";
import { getMediaType } from "../../../utils/utils";
import { BranchToBranchInwardAPIKeys } from "./entity";
var dispatch = store.dispatch;
export var BranchToBranchInwardPaging = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? BranchToBranchInwardAPIKeys.paging : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? branchToBranchInwardPagingAPI : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 ? void 0 : _res$payload.value];
        }
    });
}); };
export var branchToBranchInwardCreate = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _request$TransporterI, _request$ShippingMeth, _request$ShippingDocu, _request$ShippingDocu2, _request$VehicleNo, _request$PermitNo, _request$BoxQuantity, _res$payload2, _a, key, _b, request, _c, url, stockTransferDetails, allCompleted, hasPending, mainStatus, newRequest, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? BranchToBranchInwardAPIKeys.create : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? createBranchToBranchInwardAPI : _c;
                stockTransferDetails = (request === null || request === void 0 ? void 0 : request.StockTransferRequisitionDetail) || [];
                allCompleted = stockTransferDetails.every(function (detail) { return detail.Status === 'Completed'; });
                hasPending = stockTransferDetails.some(function (detail) { return detail.Status === 'Pending'; });
                if (allCompleted) {
                    mainStatus = 'Completed';
                }
                else if (hasPending) {
                    mainStatus = 'Partial';
                }
                else {
                    mainStatus = 'Draft';
                }
                newRequest = _objectSpread(_objectSpread({}, request), {}, {
                    Status: mainStatus,
                    TransportDetail: {
                        TransporterId: (_request$TransporterI = request === null || request === void 0 ? void 0 : request.TransporterId) !== null && _request$TransporterI !== void 0 ? _request$TransporterI : '',
                        ShippingMethodId: (_request$ShippingMeth = request === null || request === void 0 ? void 0 : request.ShippingMethodId) !== null && _request$ShippingMeth !== void 0 ? _request$ShippingMeth : '',
                        ShippingDocumentDate: (_request$ShippingDocu = request === null || request === void 0 ? void 0 : request.ShippingDocumentDate) !== null && _request$ShippingDocu !== void 0 ? _request$ShippingDocu : '',
                        ShippingDocumentNo: (_request$ShippingDocu2 = request === null || request === void 0 ? void 0 : request.ShippingDocumentNo) !== null && _request$ShippingDocu2 !== void 0 ? _request$ShippingDocu2 : '',
                        VehicleNo: (_request$VehicleNo = request === null || request === void 0 ? void 0 : request.VehicleNo) !== null && _request$VehicleNo !== void 0 ? _request$VehicleNo : '',
                        PermitNo: (_request$PermitNo = request === null || request === void 0 ? void 0 : request.PermitNo) !== null && _request$PermitNo !== void 0 ? _request$PermitNo : '',
                        BoxQuantity: (_request$BoxQuantity = request === null || request === void 0 ? void 0 : request.BoxQuantity) !== null && _request$BoxQuantity !== void 0 ? _request$BoxQuantity : ''
                    }
                });
                return [4 /*yield*/, dispatch(createAPI({
                        key: key,
                        url: url,
                        request: newRequest
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload2 = res.payload) === null || _res$payload2 === void 0 ? void 0 : _res$payload2.value];
        }
    });
}); };
export var BToBRequisitionIdAPICall = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? BranchToBranchInwardAPIKeys.RequisitionList : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? completedStockTransferRequisitionAPI : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 ? void 0 : res.payload.value];
        }
    });
}); };
export var BToBTransporterNameListAPICall = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload3, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? '' : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? TransporterListUrl : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload3 = res.payload) === null || _res$payload3 === void 0 ? void 0 : _res$payload3.value];
        }
    });
}); };
export var BToBShippingMethodListAPICall = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload4, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? 'ShippingMethodList' : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? ShippingMethodGetListAPI : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload4 = res.payload) === null || _res$payload4 === void 0 ? void 0 : _res$payload4.value];
        }
    });
}); };
export var OrganizationModulesItemSettingAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload5, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? 'OrganizationModulesItemSetting' : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? OrganizationModulesItemSettingUrl : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload5 = res.payload) === null || _res$payload5 === void 0 ? void 0 : _res$payload5.value];
        }
    });
}); };
export var getBranchToBranchInward = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload6, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? BranchToBranchInwardAPIKeys.get : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? stockTransferRequisitionWithDetailsAPI(request === null || request === void 0 ? void 0 : request.id) : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: {}
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload6 = res.payload) === null || _res$payload6 === void 0 ? void 0 : _res$payload6.value];
        }
    });
}); };
export var getStatusProgress = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload7, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? BranchToBranchInwardAPIKeys.statusProgress : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? getStatusProgessAPI : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload7 = res.payload) === null || _res$payload7 === void 0 ? void 0 : _res$payload7.value];
        }
    });
}); };
export var getAvailableQtyByWarehouse = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload8, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? "getAvailableQty" : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? getAvailableQtyByWarehouseAPI : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload8 = res.payload) === null || _res$payload8 === void 0 ? void 0 : _res$payload8.value];
        }
    });
}); };
export var getByBranchToBranchInward = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload9, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? BranchToBranchInwardAPIKeys.get : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? getByBranchToBranchInwardIdAPI : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload9 = res.payload) === null || _res$payload9 === void 0 ? void 0 : _res$payload9.value];
        }
    });
}); };
export var statusListGet = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload10, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? "" : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? StatusList : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload10 = res.payload) === null || _res$payload10 === void 0 ? void 0 : _res$payload10.value];
        }
    });
}); };
export var warehouseListGet = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload11, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? "warehouseList" : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? WarehouseList : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload11 = res.payload) === null || _res$payload11 === void 0 ? void 0 : _res$payload11.value];
        }
    });
}); };
export var branchListGet = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload12, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? "branchListGet" : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? branchListUrl : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload12 = res.payload) === null || _res$payload12 === void 0 ? void 0 : _res$payload12.value];
        }
    });
}); };
export var productListGet = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload13, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? "productList" : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? ProductList : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload13 = res.payload) === null || _res$payload13 === void 0 ? void 0 : _res$payload13.value];
        }
    });
}); };
export var adjustmentTypeListGet = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload14, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? "adjustmentTypeList" : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? AdjustmentTypeList : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload14 = res.payload) === null || _res$payload14 === void 0 ? void 0 : _res$payload14.value];
        }
    });
}); };
export var serialNumberListGet = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload15, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? "serialNumberList" : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? SerialNumberList : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload15 = res.payload) === null || _res$payload15 === void 0 ? void 0 : _res$payload15.value];
        }
    });
}); };
export var priorityListGet = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload16, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? "priorityList" : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? getPriorityListAPI : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload16 = res.payload) === null || _res$payload16 === void 0 ? void 0 : _res$payload16.value];
        }
    });
}); };
export var locationByWarehouseListGet = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload17, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? "locationByWarehouseList" : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? LocationByWarehouseList : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload17 = res.payload) === null || _res$payload17 === void 0 ? void 0 : _res$payload17.value];
        }
    });
}); };
export var getAvailableQuantityAPIGet = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload18, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? "getAvailableQuantity" : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? getAvailableQuantityAPI : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload18 = res.payload) === null || _res$payload18 === void 0 ? void 0 : _res$payload18.value];
        }
    });
}); };
export var checkDefaultTrackingTypeAPIGet = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload19, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? "checkDefaultTrackingType" : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? checkDefaultTrackingTypeAPI : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload19 = res.payload) === null || _res$payload19 === void 0 ? void 0 : _res$payload19.value];
        }
    });
}); };
export var getProductPriceAPIGet = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload20, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? "getProductPrice" : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? getProductPriceAPI : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload20 = res.payload) === null || _res$payload20 === void 0 ? void 0 : _res$payload20.value];
        }
    });
}); };
export var getOtherDetailsAPIGet = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload21, _res$payload22, _res$payload24, _a, key, _b, request, _c, url, res, _res$payload$value$da, _res$payload23, attachmentArray;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? BranchToBranchInwardAPIKeys.attachmentList : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? branchToBranchInwardOtherDetails(request === null || request === void 0 ? void 0 : request.id) : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: {}
                    }))];
            case 1:
                res = _d.sent();
                if (res !== null && res !== void 0 && (_res$payload21 = res.payload) !== null && _res$payload21 !== void 0 && (_res$payload21 = _res$payload21.value) !== null && _res$payload21 !== void 0 && _res$payload21.success && (res === null || res === void 0 || (_res$payload22 = res.payload) === null || _res$payload22 === void 0 || (_res$payload22 = _res$payload22.value) === null || _res$payload22 === void 0 ? void 0 : _res$payload22.statusCode) == 200) {
                    attachmentArray = (_res$payload$value$da = res === null || res === void 0 || (_res$payload23 = res.payload) === null || _res$payload23 === void 0 || (_res$payload23 = _res$payload23.value) === null || _res$payload23 === void 0 || (_res$payload23 = _res$payload23.data) === null || _res$payload23 === void 0 ? void 0 : _res$payload23.ImageAttachments) !== null && _res$payload$value$da !== void 0 ? _res$payload$value$da : [];
                    if ((attachmentArray === null || attachmentArray === void 0 ? void 0 : attachmentArray.length) > 0) {
                        attachmentArray === null || attachmentArray === void 0 || attachmentArray.map(function (item) {
                            getDownloadAttachmentListAPIGet({
                                request: {
                                    id: item === null || item === void 0 ? void 0 : item.id,
                                    attachmentId: item === null || item === void 0 ? void 0 : item.AttachmentId
                                }
                            });
                        });
                    }
                }
                return [2 /*return*/, res === null || res === void 0 || (_res$payload24 = res.payload) === null || _res$payload24 === void 0 ? void 0 : _res$payload24.value];
        }
    });
}); };
export var getDownloadAttachmentListAPIGet = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload25, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? BranchToBranchInwardAPIKeys.downloadAttachmentList : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? branchToBranchInwardAttachmentList(request === null || request === void 0 ? void 0 : request.id, request === null || request === void 0 ? void 0 : request.attachmentId) : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: {}
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload25 = res.payload) === null || _res$payload25 === void 0 ? void 0 : _res$payload25.value];
        }
    });
}); };
export var branchToBranchInwardAttachmentCreate = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? BranchToBranchInwardAPIKeys.uploadAttachment : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? stockTransferRequisitionAttachmentCreateAPI : _c;
                return [4 /*yield*/, dispatch(createAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 ? void 0 : res.payload.value];
        }
    });
}); };
export var branchToBranchInwardAttachmentDelete = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, key, _b, request, _c, url, state, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? 'deleteAttachment' : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? stockTransferRequisitionAttachmentDeleteAPI : _c, state = params.state;
                request.BranchToBranchInwardId = state === null || state === void 0 ? void 0 : state.BranchToBranchInwardId;
                return [4 /*yield*/, dispatch(createAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 ? void 0 : res.payload];
        }
    });
}); };
export var uploadBranchToBranchInwardAttachment = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _createRes$data, _a, key, _b, request, createRequest, createRes, url, res;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? BranchToBranchInwardAPIKeys.uploadAttachment : _a, _b = params.request, request = _b === void 0 ? {} : _b;
                createRequest = {
                    Attachments: [{
                            MediaType: getMediaType(request.data.type),
                            SystemName: 'InventoryAttachment'
                        }]
                };
                return [4 /*yield*/, branchToBranchInwardAttachmentCreate({
                        request: createRequest
                    })];
            case 1:
                createRes = _c.sent();
                url = genAttachmentURL({
                    schema: 'InventoryAttachment',
                    parentId: createRes === null || createRes === void 0 || (_createRes$data = createRes.data) === null || _createRes$data === void 0 || (_createRes$data = _createRes$data[0]) === null || _createRes$data === void 0 ? void 0 : _createRes$data.id
                });
                return [4 /*yield*/, dispatch(uploadAttachmentAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 2:
                res = _c.sent();
                return [2 /*return*/, res === null || res === void 0 ? void 0 : res.payload.value];
        }
    });
}); };
